module.exports = __webpack_public_path__ + "static/rope_of_entanglement-fb833c067ef3779d82bb991b38673631.jpeg";